export const namespaced = true;

import SchoolYearService from '@/services/SchoolYearService.js';

export const state = {
  schoolYears: [],
};

export const mutations = {
  SET_SCHOOL_YEARS(state, schoolYears) {
    state.schoolYears = schoolYears;
  },
};

export const actions = {
  fetchSchoolYears({ commit }) {
    return SchoolYearService.all().then((response) => {
      commit('SET_SCHOOL_YEARS', response.data);
    });
  },
};

export const getters = {
  getSchoolYearById: (state) => (id) => {
    return state.schoolYears.find((item) => item.id == id);
  },
};
